import { IEnvConfig } from "../types";

const config: IEnvConfig = {
    api: {
        default: {
            url: "",
            rootPath: ""
        }
    }
};

export default config;
